// NOTE: this is regular function declaration because we want to bind scope
export function enterPusherChannelAndBindEvents(
  channel_name,
  events_to_bind,
  count = 0,
  self
) {
  
    // We need to save the original this into a variable because if pusher has not loaded and we
    // need to make a recursive call to this method we lose the reference to the original this it
    // becomes undefined, rendering it useless (e.g., this.$store throws can't access $store of undefined).
    if (self === undefined) {
      self = this;
    }

    if (!window.pusher) {
      return setTimeout(() => {
        enterPusherChannelAndBindEvents(channel_name, events_to_bind, count++, self);
      }, 1000);
    }

    const channel = window.pusher.subscribe(channel_name);

    events_to_bind.forEach((event) => {
      channel.bind(event.event_name, (payload) => {
        if (event.action_name) {
          self.$store.dispatch(event.action_name, payload);
        } else if (event.handler) {
          event.handler(payload, self);
        }
      });
    });
 
}

export const leavePusherChannel = (channel_name) => {
  if (!window.pusher) {
    setTimeout(() => {
      leavePusherChannel(channel_name);
    }, 1000);
    return;
  }
  window.pusher.unsubscribe(channel_name);
  return;
};



// WEBPACK FOOTER //
// ./src/app/utils/realTimeEventHelpers.js